/**
 * 예측 속도 차트 섹션 컴포넌트
 * 
 * 주요 기능:
 * 1. 미래 교통 속도 예측 데이터 시각화
 * 2. 실시간 예측 속도 데이터 표시
 * 3. 차트 클릭 이벤트 처리
 * 
 * 데이터 처리:
 * - getPredictSpeedData: 실시간 예측 속도 데이터
 * - chartData: 차트에 표시될 데이터 포맷 변환
 * 
 * 상태 관리:
 * - searchParamState: 검색 조건 (도로, 날짜 등)
 * 
 * 차트 타입:
 * - Line 차트 사용 (ApexCharts)
 * - 마커 클릭 시 상세 정보 표시
 * 
 * 로딩 상태:
 * - 도로 미선택 시 안내 메시지
 * - 데이터 로딩 중 표시
 * - 데이터 없음 표시
 */
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { ChartData, ChartDataValue } from "../../../../interface/chart";
import { useRecoilValue } from "recoil";
import { searchParamState } from "../../../../atoms";
import Line from "../../../chart/Line";
import { predictDataApi } from "../../../../api/predictDataApi";

const PredictChartSection = () => {
  const searchParam = useRecoilValue(searchParamState);
  const [chartData, setChartData] = useState<ChartData>({
    name: searchParam.roadName,
    data: [],
  });

  // console.log("💕 PredictChart chartData", chartData);

  const { data: getPredictSpeedData, isLoading: getPredictSpeedLoading } =
    useQuery(
      ["getPredictSpeed", searchParam],
      () => predictDataApi.getPredictSpeed(searchParam.linkId),
      {
        enabled: searchParam.linkId !== "",
        keepPreviousData: true,
      },
    );

  // console.log("✅ Sidebar getPredictSpeedData", getPredictSpeedData);

  useEffect(() => {
    if (getPredictSpeedData) {
      console.log("✅ Sidebar getPredictSpeedData", getPredictSpeedData);
      let chartValues: ChartDataValue[] = [];

      getPredictSpeedData.forEach((item: any) => {
        item.items.forEach((i: any) => {
          let chartValue: ChartDataValue = {
            x: i.time,
            y: i.speed,
          };
          chartValues.push(chartValue);
        });
      });

      setChartData({
        name: searchParam.roadName,
        data: chartValues,
      });
    }
  }, [getPredictSpeedData, searchParam.roadName]);

  return (
    <>
      {searchParam.linkId === "" ? (
        <div className="w-full h-4/6 flex justify-center items-center">
          <p className="text-dark-grey font-bold">도로를 선택해주세요</p>
        </div>
      ) : getPredictSpeedLoading ? (
        <div className="w-full h-4/6 flex justify-center items-center">
          <p className="text-dark-grey font-bold">로딩 중</p>
        </div>
      ) : chartData.data?.length > 0 ? (
        <>
          <Line data={chartData} title={"현재 예측 속도"} />
        </>
      ) : (
        <div className="w-full h-4/6 flex justify-center items-center">
          <p className="text-dark-grey font-bold">해당하는 데이터가 없습니다</p>
        </div>
      )}
    </>
  );
};

export default PredictChartSection;
